import React, { Component } from 'react';
import { observer } from 'mobx-react';

import { AgGridReact } from 'ag-grid-react';
import PendingSummary from './PendingSummary';

const height = window.innerHeight * .65;

const defaultColDef = {
    sortable: true,
    resizable: true,
    filter: true,
    flex: 1,
};

const columnDefs = [
    { headerName: "S.No.",valueGetter: "node.rowIndex + 1"},
    { headerName: 'Bucket', field: 'Bucket', filter: 'agNumberColumnFilter', width: 125, headerClass: 'ag-right-aligned-header', cellClass: 'ag-right-aligned-cell' },
    { headerName: 'Date', field: 'CreatedOn', width: 75 },
    { headerName: 'SidCode', field: 'SidCode', width: 100 },
    { headerName: 'Patient Name', field: 'CustomerName', filter: 'agTextColumnFilter', width: 350 },
    { headerName: 'Bill', field: 'Total', type: 'numericColumn', filter: 'agNumberColumnFilter', width: 125, headerClass: 'ag-right-aligned-header', cellClass: 'ag-right-aligned-cell' },
    { headerName: 'IC', field: 'IC', type: 'numericColumn', filter: 'agNumberColumnFilter', width: 125, headerClass: 'ag-right-aligned-header', cellClass: 'ag-right-aligned-cell' },
]

class PendingInvoices extends Component {

    gridRef = React.createRef();

    constructor(props) {
        super(props);
        this.store = props.store;
    }

    fetchSummary = () => {
        this.store.fetchSummary(this.props.params.collectionType);
    }

    refreshGrid = () => {
        this.gridRef.current.api.redrawRows();
    }

    onSelectionChanged = () => {
        const selectedRows = this.gridRef.current.api.getSelectedRows();
        const registrationId = selectedRows[0].RegistrationId;
        const sidCode = selectedRows[0].SidCode;
        this.store.fetchRegistration(registrationId, sidCode);
    }

    render() {
        return (
            <div>
                <div className="ag-theme-alpine" style={{ height: height, width: '100%' }}>
                    <AgGridReact
                        ref={this.gridRef}
                        defaultColDef={defaultColDef}
                        rowData={this.store.payables}
                        columnDefs={columnDefs}
                        rowSelection={'single'}
                        onSelectionChanged={this.onSelectionChanged}
                        onGridReady={this.fetchSummary}
                        rowHeight={25}
                    >
                    </AgGridReact>
                </div>
                <div>
                    <PendingSummary store={this.store} />
                </div>
            </div>
        )
    }
}

export default observer(PendingInvoices)
